import { N as push, T as spread_attributes, aa as element, R as bind_props, P as pop } from "./index.js";
function classMap(classObj) {
  return Object.entries(classObj).filter(([name, value]) => name !== "" && value).map(([name]) => name).join(" ");
}
function SmuiElement($$payload, $$props) {
  push();
  let {
    use = [],
    tag = "div",
    children,
    $$slots,
    $$events,
    ...restProps
  } = $$props;
  const selfClosing = [
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
  ].indexOf(tag) > -1;
  let element$1;
  function getElement() {
    return element$1;
  }
  if (tag === "svg") {
    $$payload.out += "<!--[-->";
    $$payload.out += `<svg${spread_attributes({ ...restProps }, void 0, void 0, 3)}>`;
    children?.($$payload);
    $$payload.out += `<!----></svg>`;
  } else {
    $$payload.out += "<!--[!-->";
    if (selfClosing) {
      $$payload.out += "<!--[-->";
      element($$payload, tag, () => {
        $$payload.out += `${spread_attributes({ ...restProps })}`;
      });
    } else {
      $$payload.out += "<!--[!-->";
      element(
        $$payload,
        tag,
        () => {
          $$payload.out += `${spread_attributes({ ...restProps })}`;
        },
        () => {
          children?.($$payload);
          $$payload.out += `<!---->`;
        }
      );
    }
    $$payload.out += `<!--]-->`;
  }
  $$payload.out += `<!--]-->`;
  bind_props($$props, { getElement });
  pop();
}
export {
  SmuiElement as S,
  classMap as c
};
